/* ==========================================================================
   Casemira, l'offre de novembre dans le navigateur
   Casemira 28/10/2026 (offre de novembre)
   --------------------------------------------------------------------------
   Charge en `defer` par layout/theme.liquid, seulement si l'offre est cochee.

   CE QUE CE FICHIER FAIT
     1. Lit la configuration posee par `snippets/casemira-offre.liquid`
        (<script type="application/json" id="cm-offre-config">) : seuils et
        montants en centimes des trois jeux, pourcentages maximaux, dates ISO,
        devise du panier, gabarit monetaire. Aucun mot dans ce JSON.
     2. Reprend la periode decidee dans le <head> par
        `snippets/casemira-offre-tete.liquid` (window.CM_OFFRE_TETE) : une seule
        logique de periode dans tout le theme, horloge simulee de recette
        comprise. Sans elle (cas d'ecole), la periode de repli du serveur.
     3. Expose window.CM_OFFRE, emet `cm-offre-prete` sur `document`.
     4. Chaque minute (calee sur la minute pleine) : met a jour les comptes a
        rebours `[data-cm-rebours]`, et recalcule la periode. Au passage de
        minuit (heure de Paris, puisque les bornes le sont), `data-periode`
        change sur <html> sans rechargement et `cm-offre-periode` est emis.
     5. Emet `cm-offre-ouvrir` sur `document` quand l'adresse porte `offre=1`
        ou le fragment `#comment` (contrat avec la fenetre d'explication du
        lot 2, qui l'ecoute).

   AUCUN TEXTE FACE CLIENT ICI. Les phrases viennent des cles de locale
   `casemira.offre_q4.*`, passees par Liquid en attributs `data-*` ;
   `CM_OFFRE.gabarit(modele, valeurs)` y remplace les `{{ nom }}`. Les seuls
   mots du fichier sont les replis du compte a rebours, utilises uniquement
   si les attributs de `#cm-offre-config` manquaient : ils recopient la cle fr.

   window.CM_OFFRE
     periode              socle | black_week | black_friday | black_weekend |
                          cyber_monday | decembre
     famille              jeu de montants : socle | black_week | black_friday
     actif                faux si l'offre est terminee (periode decembre ou
                          forcee a decembre)
     seuils               [19900, 29900, 49900, 79900] (centimes, euros)
     seuilsDevise         les memes au taux Shopify.currency.rate (centimes de
                          la devise du panier, arrondis), pour la jauge hors euro
     montants             les quatre montants de la famille (centimes)
     montantMax           le plus haut des quatre
     pctMax               pourcentage maximal de la famille
     finEvenement         Date de fin de l'evenement du jour : jeudi 19 a minuit
                          (socle), jeudi 26 (black_week), vendredi 27
                          (black_friday), dimanche 29 (black_weekend), lundi 30
                          (cyber_monday) ; null en decembre
     finOffre             Date de fin de l'offre (1er decembre 0 h)
     horsEuro             vrai si la devise du panier n'est pas l'euro
     montantsAffichables  faux hors euro et en vue `sans-prix`
     taux                 Shopify.currency.rate (1 en euro)
     racine               routes.root_url (« / », « /de », ...)
     maintenant()         l'instant courant (ms), horloge simulee comprise
     format(centimes)     montant formate dans le format de la page, sans
                          decimales nulles (gabarit de cm-prix)
     compteARebours(date) « 11 h 23 min » / « 1 j 14 h » : au-dessus de 24 h,
                          jours et heures ; en dessous, heures et minutes ;
                          sous une heure, minutes ; jamais de secondes
     decompte(date)       les memes nombres, sans mots : { jours, heures,
                          minutes, longue } (longue : 24 h ou plus) ; sert
                          aux blocs (retours 2, 28/10/2026)
     gabarit(modele, valeurs)  remplace {{ nom }} ; un nom absent est vide
     majRebours()         force la mise a jour des comptes a rebours (apres une
                          injection de HTML, par exemple)

     majMontants(racine)  reecrit, dans `racine` (element, ou document), les
                          montants rendus par Liquid pour la periode de repli
                          avec ceux de la periode du jour (voir plus bas)

   [data-cm-offre-surface]                  ajout lot 3, 28/10/2026
     Toute surface d'offre hors barre haute (hero, section « L'offre »,
     mega-menu, menu telephone) porte cet attribut sur sa racine : ce fichier
     y appelle majMontants() au demarrage (avant `cm-offre-prete`) et a chaque
     passage de minuit (avant `cm-offre-periode`). La barre haute et sa fenetre
     gardent leur propre routine (assets/casemira-topbar.js, meme motif) et ne
     portent pas l'attribut : rien n'est ecrit deux fois.
     Dans la racine :
       [data-cm-montant="1..4"]  montant du palier, formate (format()) ;
                                 avec `data-cm-devise-petite`, la devise passe
                                 en <small> (« 20<small>€</small> »)
       [data-cm-seuil="1..4"]    seuil du palier, formate
       [data-cm-montant-max]     le plus haut des quatre montants
       [data-cm-pct]             le pourcentage maximal (marches hors euro)
       [data-cm-hors-euro]       recoit ou perd la classe `cm-hors-euro` selon
                                 montantsAffichables (la racine comprise)
     Hors euro, les montants ne sont pas reecrits (ils seraient faux) : la
     surface affiche sa variante en pourcentage.

   [data-cm-rebours]
     valeur vide ou « evenement » : vers finEvenement ; « offre » : vers
     finOffre ; sinon une date ISO. Si l'element porte `data-cm-gabarit`
     (« Black Friday. Fin dans {{ rebours }}. »), le texte entier est
     recompose ; sinon seul le compte a rebours est ecrit.

   [data-cm-rebours-blocs]                  ajout retours 2, 28/10/2026
     Mode « blocs » (fenetre d'explication et section « L'offre », du 20 au
     30) : la valeur choisit la cible comme ci-dessus. Le conteneur a trois
     enfants `[data-unite="jours|heures|minutes"]` ; au-dessus de 24 h, jours
     et heures sont montres, en dessous heures et minutes, l'autre recoit
     `hidden`. Dans chaque enfant :
       [data-cm-valeur]   recoit le nombre ;
       [data-cm-libelle]  recoit l'unite, lue dans les attributs de l'enfant :
                          `data-un` si le nombre vaut 1, sinon `data-autre`
                          (cles casemira.offre_q4.rebours.unite_*, rendues
                          par Liquid, aucun mot ici).
     Mis a jour chaque minute avec les autres comptes a rebours, jamais de
     secondes, rien d'anime. Le mode texte ci-dessus (barre du jour) n'est
     pas touche.
   ========================================================================== */
(function () {
  'use strict';

  if (window.CM_OFFRE) return;

  var el = document.getElementById('cm-offre-config');
  if (!el) return;
  var CFG;
  try {
    CFG = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }

  var TETE = window.CM_OFFRE_TETE || null;
  var FAMILLE = {
    socle: 'socle',
    black_week: 'black_week',
    black_friday: 'black_friday',
    black_weekend: 'black_friday',
    cyber_monday: 'black_friday',
    decembre: 'socle'
  };
  /* La fin de l'evenement du jour est le debut de la periode suivante. */
  var SUIVANTE = {
    socle: 'black_week',
    black_week: 'black_friday',
    black_friday: 'black_weekend',
    black_weekend: 'cyber_monday',
    cyber_monday: 'fin'
  };
  var REPLIS_MONTANTS = {
    socle: [2000, 3000, 5000, 8000],
    black_week: [3000, 4500, 7500, 12000],
    black_friday: [4000, 6000, 10000, 16000]
  };
  var REPLIS_PCT = { socle: 10, black_week: 15, black_friday: 20 };

  function maintenant() {
    return TETE ? TETE.maintenant() : Date.now();
  }

  function borne(nom) {
    if (TETE && TETE.bornes && !isNaN(TETE.bornes[nom])) return TETE.bornes[nom];
    return Date.parse((CFG.dates || {})[nom]);
  }

  /* Avant-première Black Week (SPEC-ACCES-ANTICIPE, 29/10) : vrai pour le
     visiteur venu par le lien du mail, entre le début de l'avant-première et la
     Black Week publique. Décidé dans la tête de page, lu ici. */
  function accesA(t) {
    return !!(TETE && typeof TETE.accesActif === 'function' && TETE.accesActif(t));
  }

  function periodeA(t) {
    if (TETE) return TETE.periode(t);
    if (CFG.periodeForcee && CFG.periodeForcee !== 'aucune') return CFG.periodeForcee;
    return CFG.periodeRepli || 'socle';
  }

  function entiers(liste, repli) {
    if (!liste || liste.length !== 4) return repli.slice();
    return liste.map(function (v, i) {
      var n = parseInt(v, 10);
      return isNaN(n) ? repli[i] : n;
    });
  }

  /* ── Format monetaire ─────────────────────────────────────────────────── */
  var SANS_DECIMALES = {
    amount: 'amount_no_decimals',
    amount_with_comma_separator: 'amount_no_decimals_with_comma_separator',
    amount_with_space_separator: 'amount_no_decimals_with_space_separator'
  };

  function grouper(entier, sep) {
    return entier.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function format(centimes) {
    var modele = CFG.format || '{{amount_no_decimals_with_comma_separator}} €';
    var jeton = /\{\{\s*(\w+)\s*\}\}/.exec(modele);
    var nom = jeton ? jeton[1] : 'amount_no_decimals_with_comma_separator';
    var c = Math.round(Number(centimes) || 0);
    /* Sans decimales nulles : un montant rond perd ses centimes, un montant
       qui en a les garde (meme regle que `money_without_trailing_zeros`). */
    if (c % 100 !== 0) {
      for (var k in SANS_DECIMALES) {
        if (SANS_DECIMALES[k] === nom) nom = k;
      }
    }
    var dec = nom.indexOf('no_decimals') > -1 ? 0 : 2;
    var brut = (c / 100).toFixed(dec).split('.');
    var mil = ',';
    var sepDec = '.';
    if (nom.indexOf('comma_separator') > -1) {
      mil = '.';
      sepDec = ',';
    } else if (nom.indexOf('space_separator') > -1) {
      mil = ' ';
      sepDec = ',';
    } else if (nom.indexOf('apostrophe_separator') > -1) {
      mil = "'";
    }
    var nombre = grouper(brut[0], mil) + (brut[1] ? sepDec + brut[1] : '');
    /* 31/10 : en français dans un marché hors euro, Shopify sert le gabarit de la
       devise avec décimales (« {{amount_with_space_separator}} kr ») ; un montant
       rond perd ses « ,00 », comme partout ailleurs. */
    if (c % 100 === 0) nombre = nombre.replace(/[.,]00$/, '');
    return jeton ? modele.replace(jeton[0], nombre) : nombre;
  }

  /* ── Gabarits ─────────────────────────────────────────────────────────── */
  function gabarit(modele, valeurs) {
    valeurs = valeurs || {};
    return String(modele == null ? '' : modele).replace(/\{\{\s*(\w+)\s*\}\}/g, function (tout, nom) {
      return valeurs[nom] == null ? '' : String(valeurs[nom]);
    });
  }

  var G = {
    jours: el.getAttribute('data-rebours-jours') || '{{ jours }} j {{ heures }} h',
    heures: el.getAttribute('data-rebours-heures') || '{{ heures }} h {{ minutes }} min',
    minutes: el.getAttribute('data-rebours-minutes') || '{{ minutes }} min'
  };

  /* Les nombres du compte a rebours, sans mots. Au-dessus de 24 h : jours et
     heures pleines ; en dessous : heures et minutes pleines restantes, comme
     une horloge qui decompte, plancher a 1 minute (jamais « 0 min » tant qu'il
     reste du temps). */
  function decompte(date) {
    var fin = date instanceof Date ? date.getTime() : Number(date);
    if (isNaN(fin)) return null;
    var reste = Math.max(0, fin - maintenant());
    var MIN = 60000;
    var HEURE = 60 * MIN;
    var JOUR = 24 * HEURE;
    if (reste >= JOUR) {
      return { longue: true, jours: Math.floor(reste / JOUR), heures: Math.floor((reste % JOUR) / HEURE), minutes: 0 };
    }
    var minutes = reste > 0 ? Math.max(1, Math.floor(reste / MIN)) : 0;
    if (minutes >= 24 * 60) return { longue: true, jours: 1, heures: 0, minutes: 0 };
    return { longue: false, jours: 0, heures: Math.floor(minutes / 60), minutes: minutes % 60 };
  }

  function compteARebours(date) {
    var n = decompte(date);
    if (!n) return '';
    if (n.longue) return gabarit(G.jours, { jours: n.jours, heures: n.heures });
    if (n.heures > 0) return gabarit(G.heures, { heures: n.heures, minutes: n.minutes });
    return gabarit(G.minutes, { minutes: n.minutes });
  }

  /* ── Montants des surfaces (lot 3, 28/10/2026) ─────────────────────────
     Meme motif que assets/casemira-topbar.js (lot 2), centralise ici pour le
     hero, la section « L'offre » et les deux menus. */
  function echappe(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* « 20 € » -> « 20<small>€</small> » (grands chiffres de la section). */
  function deviseEnPetit(f) {
    var m = /^(\D*?)(\d(?:[\d.,'\s]*\d)?)(\D*)$/.exec(f);
    if (!m) return echappe(f);
    var avant = m[1].trim();
    var apres = m[3].trim();
    /* 31/10 : « 20€ » reste collé (symbole), mais une unité en lettres (kr, Kč,
       Ft, lei, hors euro) prend une espace fine insécable : « 1 775 kr ». */
    var sep = /^[A-Za-z\u00C0-\u024F]/.test(apres) ? '\u202f' : '';
    return (avant ? '<small>' + echappe(avant) + '</small>' : '') + echappe(m[2]) + (apres ? sep + '<small>' + echappe(apres) + '</small>' : '');
  }

  function dans(racine, selecteur) {
    var liste = Array.prototype.slice.call(racine.querySelectorAll(selecteur));
    if (racine.matches && racine.matches(selecteur)) liste.unshift(racine);
    return liste;
  }

  function ecrire(n, valeur, html) {
    if (html) {
      if (n.innerHTML !== valeur) n.innerHTML = valeur;
    } else if (n.textContent !== valeur) {
      n.textContent = valeur;
    }
  }

  function majMontants(racine) {
    racine = racine || document;
    if (!racine.querySelectorAll) return;
    var O = window.CM_OFFRE;
    if (!O) return;
    var affichables = O.montantsAffichables !== false;
    dans(racine, '[data-cm-hors-euro]').forEach(function (n) {
      n.classList.toggle('cm-hors-euro', !affichables);
    });
    if (affichables) {
      dans(racine, '[data-cm-montant]').forEach(function (n) {
        var c = (O.montantsAff || O.montants || [])[parseInt(n.getAttribute('data-cm-montant'), 10) - 1];
        if (c == null) return;
        var f = formatMontant(c);
        if (n.hasAttribute('data-cm-devise-petite')) ecrire(n, deviseEnPetit(f), true);
        else ecrire(n, f);
      });
      dans(racine, '[data-cm-seuil]').forEach(function (n) {
        var c = (O.seuilsAff || O.seuils || [])[parseInt(n.getAttribute('data-cm-seuil'), 10) - 1];
        if (c != null) ecrire(n, format(c));
      });
      dans(racine, '[data-cm-montant-max]').forEach(function (n) {
        if (O.montantMaxAff || O.montantMax) ecrire(n, formatMontant(O.montantMaxAff || O.montantMax));
      });
    }
    dans(racine, '[data-cm-pct]').forEach(function (n) {
      if (O.pctMax != null) ecrire(n, String(O.pctMax));
    });
  }

  function majSurfaces() {
    var liste = document.querySelectorAll('[data-cm-offre-surface]');
    for (var i = 0; i < liste.length; i++) majMontants(liste[i]);
  }

  /* ── L'objet public ───────────────────────────────────────────────────── */
  var taux = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
  if (!(taux > 0)) taux = 1;
  var devise = CFG.devise || 'EUR';
  var horsEuro = devise !== 'EUR';
  var seuils = entiers(CFG.seuils, [19900, 29900, 49900, 79900]);

  /* ── Hors euro : ÉQUIVALENCES ARRONDIES (Raphaël, 31/10 11 h 58) ─────────
     Les remises Shopify sont en euros ; dans un marché en couronnes, forints ou
     lei, Shopify les convertit au taux du jour, le même que celui des prix
     (`Shopify.currency.rate`). Plutôt qu'un pourcentage, le site montre le
     même escalier en monnaie locale :
       · seuils ARRONDIS AU PAS SUPÉRIEUR (« dès 1 050 lei ») : le seuil écrit
         n'est jamais plus bas que celui que Shopify exigera ;
       · montants ARRONDIS PAR LE BAS au pas « joli » de la devise (Raphaël,
         31/10 12 h 54 : jamais annoncer plus que ce que le checkout déduit,
         même de quelques centimes ; et des chiffres ronds comme en euros, pas
         445 ou 1 795). Exemple Suède, Black Friday : 449,47 kr exacts → 425 kr ;
         674,20 → 650 ; 1 123,67 → 1 100 ; 1 797,87 → 1 775. Le client reçoit
         toujours un peu plus que l'annonce. Pas de « ≈ » (12 h 38).
     Le pas dépend de la devise (seuil, montant). Sans taux lisible, ou en vue
     « sans prix », l'ancien repli en pourcentage reste (`cm-hors-euro`). */
  var PAS = { SEK: [50, 25], DKK: [50, 25], CZK: [100, 50], HUF: [1000, 500], RON: [50, 5] };
  var pas = PAS[devise] || [10, 1];
  var equivalence = horsEuro && taux > 0 && taux !== 1 && CFG.sansPrix !== true;
  function arrondiHaut(c, p) { var u = p * 100; return Math.ceil(c / u) * u; }
  function arrondiJoli(c, p) { var u = p * 100; return Math.max(u, Math.floor(c / u) * u); }
  /* Gardé pour les appelants (topbar, panier) : même format qu'un montant. */
  function formatMontant(c) { return format(c); }
  var seuilsAff = equivalence ? seuils.map(function (s) { return arrondiHaut(s * taux, pas[0]); }) : seuils;

  var O = {
    periode: '',
    famille: '',
    actif: false,
    seuils: seuils,
    seuilsDevise: seuils.map(function (s) {
      return Math.round(s * taux);
    }),
    montants: [],
    montantMax: 0,
    /* Ce qui s'ÉCRIT : en euro les valeurs exactes ; hors euro les
       équivalences arrondies (voir plus haut). Les comparaisons du panier
       restent sur `seuilsDevise` (exact). */
    seuilsAff: seuilsAff,
    montantsAff: [],
    montantMaxAff: 0,
    equivalence: equivalence,
    pctMax: 0,
    finEvenement: null,
    finOffre: isNaN(borne('fin')) ? null : new Date(borne('fin')),
    horsEuro: horsEuro,
    montantsAffichables: (!horsEuro && CFG.affichable !== false) || equivalence,
    taux: taux,
    devise: devise,
    racine: CFG.racine || '/',
    maintenant: maintenant,
    format: format,
    formatMontant: formatMontant,
    compteARebours: compteARebours,
    decompte: decompte,
    gabarit: gabarit,
    majRebours: majRebours,
    majMontants: majMontants
  };

  function appliquer(p) {
    var fam = FAMILLE[p] || 'socle';
    O.periode = p;
    O.famille = fam;
    O.actif = CFG.actif !== false && p !== 'decembre';
    O.montants = entiers((CFG.montants || {})[fam], REPLIS_MONTANTS[fam]);
    O.montantMax = Math.max.apply(null, O.montants);
    O.montantsAff = equivalence ? O.montants.map(function (m) { return arrondiJoli(m * taux, pas[1]); }) : O.montants;
    O.montantMaxAff = Math.max.apply(null, O.montantsAff);
    /* Montants LONGS (4 chiffres et plus : couronnes tchèques, forints) : les
       escaliers et la jauge réduisent leurs chiffres (règles CSS sur cet
       attribut), sinon « ≈ 30 000 Ft » déborde de sa marche au téléphone. */
    var chiffres = String(Math.round(O.montantMaxAff / 100)).length;
    if (equivalence && chiffres >= 4) document.documentElement.setAttribute('data-cm-montants-longs', String(chiffres));
    else document.documentElement.removeAttribute('data-cm-montants-longs');
    var pct = parseInt((CFG.pctMax || {})[fam], 10);
    O.pctMax = isNaN(pct) ? REPLIS_PCT[fam] : pct;
    var fin = SUIVANTE[p] ? borne(SUIVANTE[p]) : NaN;
    O.finEvenement = isNaN(fin) ? null : new Date(fin);
    if (document.documentElement.getAttribute('data-periode') !== p) {
      document.documentElement.setAttribute('data-periode', p);
    }
    /* Noir tout le mois (Raphaël 29/10) : `data-cm-noir` suit la période, sauf décembre. */
    if (p !== 'decembre') document.documentElement.setAttribute('data-cm-noir', '');
    else document.documentElement.removeAttribute('data-cm-noir');
    /* Avant-première : `data-cm-acces` sur <html> (mention « réservée à nos
       inscrits ») et les codes que le panier pose, un par palier. */
    O.acces = accesA(maintenant());
    O.accesCodes = (CFG.accesCodes || []).map(function (c) { return String(c).trim().toUpperCase(); }).filter(Boolean);
    if (O.acces) document.documentElement.setAttribute('data-cm-acces', '');
    else document.documentElement.removeAttribute('data-cm-acces');
  }

  function emettre(nom, detail) {
    var ev;
    try {
      ev = new CustomEvent(nom, { detail: detail });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(nom, false, false, detail);
    }
    document.dispatchEvent(ev);
  }

  /* ── Comptes a rebours ────────────────────────────────────────────────── */
  function cible(valeur) {
    if (!valeur || valeur === 'evenement') return O.finEvenement;
    if (valeur === 'offre') return O.finOffre;
    var t = Date.parse(valeur);
    return isNaN(t) ? null : new Date(t);
  }

  /* Mode « blocs » (retours 2, 28/10/2026) : un nombre et son unite par
     bloc ; voir l'en-tete, [data-cm-rebours-blocs]. */
  function majBlocs(n, valeurs) {
    var montre = valeurs.longue ? { jours: 1, heures: 1 } : { heures: 1, minutes: 1 };
    var blocs = n.querySelectorAll('[data-unite]');
    for (var i = 0; i < blocs.length; i++) {
      var b = blocs[i];
      var u = b.getAttribute('data-unite');
      var voir = !!montre[u];
      if (b.hidden === voir) b.hidden = !voir;
      if (!voir) continue;
      var v = valeurs[u] || 0;
      var champ = b.querySelector('[data-cm-valeur]');
      if (champ && champ.textContent !== String(v)) champ.textContent = String(v);
      var lib = b.querySelector('[data-cm-libelle]');
      var mot = b.getAttribute(v === 1 ? 'data-un' : 'data-autre');
      if (lib && mot != null && lib.textContent !== mot) lib.textContent = mot;
    }
  }

  function majRebours() {
    var liste = document.querySelectorAll('[data-cm-rebours]');
    for (var i = 0; i < liste.length; i++) {
      var n = liste[i];
      var date = cible(n.getAttribute('data-cm-rebours'));
      if (!date) continue;
      var rebours = compteARebours(date);
      var modele = n.getAttribute('data-cm-gabarit');
      var texte = modele ? gabarit(modele, { rebours: rebours }) : rebours;
      if (n.textContent !== texte) n.textContent = texte;
    }
    var blocs = document.querySelectorAll('[data-cm-rebours-blocs]');
    for (var j = 0; j < blocs.length; j++) {
      var dateB = cible(blocs[j].getAttribute('data-cm-rebours-blocs'));
      var valeurs = dateB ? decompte(dateB) : null;
      if (valeurs) majBlocs(blocs[j], valeurs);
    }
  }

  /* ── La minute ────────────────────────────────────────────────────────── */
  var minuteur = null;

  function battre() {
    var p = periodeA(maintenant());
    /* Le lundi 23 à 0 h, la période ne change pas pour le visiteur en
       avant-première (Black Week avant, Black Week après) mais la mention tombe. */
    if (p !== O.periode || accesA(maintenant()) !== O.acces) {
      var avant = O.periode;
      appliquer(p);
      majSurfaces();
      emettre('cm-offre-periode', { periode: p, precedente: avant });
    }
    majRebours();
  }

  function planifier() {
    clearTimeout(minuteur);
    /* Calee sur la minute pleine, plus une marge : le passage de minuit et la
       minute affichee tombent ensemble. */
    var delai = 60000 - (maintenant() % 60000) + 250;
    minuteur = setTimeout(function () {
      battre();
      planifier();
    }, delai);
  }

  /* Un onglet en arriere-plan ralentit ses minuteurs : au retour, on recale. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      battre();
      planifier();
    }
  });

  /* ── Demarrage ────────────────────────────────────────────────────────── */
  appliquer(periodeA(maintenant()));
  window.CM_OFFRE = O;

  function demandeOuverture() {
    var oui = false;
    try {
      oui = new URLSearchParams(location.search).get('offre') === '1';
    } catch (e) {
      oui = /[?&]offre=1(&|$)/.test(location.search);
    }
    return oui || location.hash === '#comment';
  }
  O.ouvertureDemandee = demandeOuverture();

  /* Les deux evenements partent au DOMContentLoaded : tous les scripts `defer`
     de la page (fenetre, bandeau, panier) ont alors pose leurs ecouteurs. Les
     retardataires lisent `CM_OFFRE.prete` et `CM_OFFRE.ouvertureDemandee`. */
  var lance = false;
  function lancer() {
    if (lance) return;
    lance = true;
    O.prete = true;
    majSurfaces();
    majRebours();
    planifier();
    emettre('cm-offre-prete', O);
    if (O.ouvertureDemandee) emettre('cm-offre-ouvrir', { source: 'adresse' });
  }
  if (document.readyState === 'complete') {
    lancer();
  } else {
    document.addEventListener('DOMContentLoaded', lancer);
    window.addEventListener('load', lancer);
  }

  window.addEventListener('hashchange', function () {
    if (location.hash === '#comment') emettre('cm-offre-ouvrir', { source: 'ancre' });
  });
})();
